var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* eslint-disable prettier/prettier */
// 人员选择器 右侧组件
import React, { useMemo } from 'react';
import { List, Empty } from 'antd';
import UserSelectionContext from './context';
import TabPaneListItem from './tabs/TabPaneListItem';
import InputArea from '../UserSelectionModal/InputArea';
import { InputPlacement } from '../UserSelectionModal/types';
import InputAreaContext from '../UserSelectionModal/context';
import { SelectorMode } from './types';
import closeIcon from '../images/log_del.png';
import orgAvatarPng from '../images/default_dept_avatar.png';
import workLineAvatarPng from '../images/default_virtual_avatar.png';
import { getHeadImgThumbUrl } from '../utils';
import Avatar from '../Avatar';
import arrowRightIcon from '../images/app_ic_arrow_right.png';
import events from '../events';
export default function RightSide(_a) {
    var onItemDelete = _a.onItemDelete, data = _a.data, customAreaExtra = _a.customAreaExtra, rightExtra = _a.rightExtra, rightHeaderExtra = _a.rightHeaderExtra, onChangeItem = _a.onChangeItem, onChangeDataAll = _a.onChangeDataAll, 
    // ...rest
    despInputValue = _a.despInputValue, extraInputValue = _a.extraInputValue, leaveWordInputValue = _a.leaveWordInputValue, strangerLeaveWordInputValue = _a.strangerLeaveWordInputValue, onInputDespChange = _a.onInputDespChange, onInputExtraChange = _a.onInputExtraChange, onInputLeaveWordChange = _a.onInputLeaveWordChange, onInputStrangerLeaveWordChange = _a.onInputStrangerLeaveWordChange, maxNumber = _a.maxNumber;
    var _b = React.useContext(UserSelectionContext), frozenIds = _b.frozenIds, t = _b.t, single = _b.single, defaultUserAvatar = _b.defaultUserAvatar, hasItemSelector = _b.hasItemSelector, itemSelectorOptions = _b.itemSelectorOptions, 
    // mode,
    selectedCountText = _b.selectedCountText, maxSelectedNum = _b.maxSelectedNum, isForwardMode = _b.isForwardMode, maxSelectedSingleNum = _b.maxSelectedSingleNum, defaultLimitOpt = _b.defaultLimitOpt, selectedLimit = _b.selectedLimit, setSelectedLimit = _b.setSelectedLimit;
    var _c = React.useContext(InputAreaContext), newMode = _c.newMode, strangerResult = _c.strangerResult, setNewMode = _c.setNewMode;
    var inputPlacement = React.useContext(InputAreaContext).inputPlacement;
    // const {
    //     despInputValue,
    //     extraInputValue,
    //     leaveWordInputValue,
    //     onInputDespChange,
    //     onInputExtraChange,
    //     onInputLeaveWordChange,
    // } = rest;
    var totalCount = useMemo(function () {
        if (newMode === SelectorMode.stranger) {
            return strangerResult.length;
        }
        var res = __spreadArrays(data, strangerResult);
        if (res.length === 0) {
            return 0;
        }
        return (res || []).reduce(function (total, item) {
            var tempTotal = total;
            // if (item.isDept) {
            //     const { contactNumber } = item.origin;
            //     tempTotal += isNumber(contactNumber) ? contactNumber : 0;
            // } else {
            tempTotal += 1;
            // }
            return tempTotal;
        }, 0);
    }, [data, newMode, strangerResult]);
    // const total = data.length;
    var maxSingleNumber = maxSelectedSingleNum > 1000 ? 1000 : maxSelectedSingleNum;
    var extra = function (item) { return (React.createElement("div", null,
        React.createElement("div", { className: "focus-user-selection-right-close", onClick: function () {
                onItemDelete(item);
            }, onKeyDown: function () { }, tabIndex: 0, role: "button" },
            React.createElement("img", { src: closeIcon, alt: "" })))); };
    var strangeResultNode = useMemo(function () {
        return (strangerResult.length > 0 &&
            newMode !== SelectorMode.stranger && (React.createElement("div", { className: "strange-result", onClick: function () {
                setNewMode(SelectorMode.stranger);
            } },
            "\u975E\u8054\u7CFB\u4EBA",
            React.createElement(List, { className: "stranger-result-list", dataSource: strangerResult.slice(0, 4), locale: { emptyText: '暂无数据' }, renderItem: function (item) {
                    var _a, _b;
                    return (React.createElement(Avatar, { tag: item.accountType === 1 ||
                            ((_b = (_a = item.origin) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.accountType) === 1
                            ? '公共账号'
                            : '', className: "strange-avatar", src: getHeadImgThumbUrl(item.avatar, 150, 150), name: item.name || item.realName }));
                } }),
            React.createElement("span", { className: "stranger-result-count" },
                strangerResult.length > 4 && '...',
                "\u5171",
                strangerResult.length,
                "\u4EBA",
                React.createElement("img", { src: arrowRightIcon, width: 12 })))));
    }, [newMode, setNewMode, strangerResult]);
    return (React.createElement("div", { className: "userSelectionModalRight" },
        React.createElement("div", { className: "selected-count", style: { borderBottom: strangerResult.length > 0 ? 'none' : '1px solid #f0f0f0' } },
            React.createElement("p", null,
                React.createElement("span", null, (newMode === SelectorMode.group
                    ? selectedCountText || '群管理员' // t('userSelection.hasSelectedAdmin')
                    : selectedCountText || '已选' // t('userSelection.hasSelected')
                ) + ": "),
                React.createElement("span", { className: "selected-count-number" },
                    totalCount,
                    !defaultLimitOpt && newMode !== SelectorMode.stranger && !isForwardMode && "/" + maxNumber)),
            rightHeaderExtra && (React.createElement("div", { className: "selected-right-header-extra" }, rightHeaderExtra(data, events, { selectedLimit: selectedLimit })))),
        strangeResultNode,
        React.createElement("div", { className: "selected-container" }, (data || []).length === 0 ? (React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u6682\u65E0\u6570\u636E" })) : (React.createElement(List, { dataSource: data, locale: { emptyText: '暂无数据' }, renderItem: function (item) {
                var freeze = (frozenIds || []).findIndex(function (a) { return a === item.id; }) >= 0;
                var ext = extra(item);
                var avatar = item.avatar;
                if (freeze || single || rightExtra) {
                    ext = null;
                }
                if (item.isDept && !item.avatar) {
                    avatar = item.nodeType === '1' ? workLineAvatarPng : orgAvatarPng;
                }
                return (React.createElement(TabPaneListItem, { defualtImg: defaultUserAvatar, disabled: freeze, className: item.groupId || item.gid
                        ? 'focus-user-selection-right-item groupCanBeSel-item-list'
                        : 'focus-user-selection-right-item', extra: ext, data: __assign(__assign({}, item), { avatar: avatar }), hasItemSelector: hasItemSelector, itemSelectorOptions: itemSelectorOptions, rightExtra: rightExtra, onItemDelete: onItemDelete, onChangeItem: onChangeItem, onChangeDataAll: onChangeDataAll }));
            } }))),
        newMode === SelectorMode.stranger && (React.createElement("div", { className: "strangerInputArea" },
            React.createElement("p", null, "\u5411\u975E\u8054\u7CFB\u4EBA\u53D1\u9001\u5165\u7EC4\u9080\u8BF7\uFF08\u5FC5\u586B\uFF09\uFF0C\u5176\u540C\u610F\u540E\u53EF\u5165\u7EC4\uFF1A"),
            React.createElement(InputArea, { onInputStrangerLeaveWordChange: onInputStrangerLeaveWordChange, onInputLeaveWordChange: onInputLeaveWordChange, onInputDespChange: onInputDespChange, onInputExtraChange: onInputExtraChange, despInputValue: despInputValue, extraInputValue: extraInputValue, leaveWordInputValue: leaveWordInputValue, strangerLeaveWordInputValue: strangerLeaveWordInputValue }))),
        newMode !== SelectorMode.stranger &&
            inputPlacement &&
            inputPlacement === InputPlacement.bodyRightBottom && (React.createElement(InputArea, { onInputStrangerLeaveWordChange: onInputStrangerLeaveWordChange, onInputLeaveWordChange: onInputLeaveWordChange, onInputDespChange: onInputDespChange, onInputExtraChange: onInputExtraChange, despInputValue: despInputValue, extraInputValue: extraInputValue, leaveWordInputValue: leaveWordInputValue, strangerLeaveWordInputValue: strangerLeaveWordInputValue })),
        newMode !== SelectorMode.stranger && customAreaExtra && (React.createElement("div", { className: "custom-area-extra" }, customAreaExtra))));
}
//# sourceMappingURL=RightSide.js.map